import ms from "ms";
import { makeZeroArgHook } from "../../utils/makeZeroArgHook";
import getTaskTypes from "../requests/getTaskTypes";
import { taskTypesUrl } from "../requests/urls";
const useGetTaskTypes = makeZeroArgHook(async (auth) => getTaskTypes(auth), () => [taskTypesUrl("v4")], { staleTime: ms("1minute") });
export default useGetTaskTypes;
//# sourceMappingURL=useGetTaskTypes.js.map